<div class="line-item-wrapper">
    <div class="line-item-row">
        <div class="line-item-column col-operating">
            <label>Operating From</label>
            <p-autoComplete #autocompleteOperatingFrom [(ngModel)]="lineItemModel.operatingFrom"
                [suggestions]="filteredOperatingFromList" (completeMethod)="search($event, true)" [dropdown]="true"
                field="commonName" styleClass="autocomplete" (onBlur)="operatingFromSelected()"
                [ngClass]="{'invalid': lineItemModel.errorMessageOperatingFrom !== null}"></p-autoComplete>
            <div [hidden]="lineItemModel.errorMessageOperatingFrom === null">
                <p class="error-text">{{lineItemModel.errorMessageOperatingFrom}}</p>
            </div>
        </div>
        <div class="line-item-column col-track">
            <label>Track</label>
            <p-dropdown [options]="trackListOperatingFrom" class="track" [(ngModel)]="lineItemModel.selectedTrackFrom"
                placeholder="Select Track"
                [ngClass]="{'invalid-track': lineItemModel.errorMessageSelectedTrackFrom !== null}" field="label"
                (onBlur)="loadDirectionDropdown(null)" (onChange)="onTrackFromChange($event)"></p-dropdown>
            <div [hidden]="lineItemModel.errorMessageSelectedTrackFrom === null">
                <p class="error-text">{{lineItemModel.errorMessageSelectedTrackFrom}}</p>
            </div>
        </div>
    </div>
    <div class="line-item-row">
        <div class="line-item-column col-operating">
            <label> Operating To </label>
            <p-autoComplete #autocompleteOperatingTo [(ngModel)]="lineItemModel.operatingTo"
                [suggestions]="filteredOperatingToList" (completeMethod)="search($event, false)" [dropdown]="true"
                field="commonName" styleClass="autocomplete" (onBlur)="operatingToSelected()"
                [ngClass]="{'invalid': lineItemModel.errorMessageOperatingTo !== null}"></p-autoComplete>
            <div [hidden]="lineItemModel.errorMessageOperatingTo === null">
                <p class="error-text">{{lineItemModel.errorMessageOperatingTo}}</p>
            </div>
        </div>

        <div class="line-item-column col-track">
            <label> Track </label>
            <p-dropdown [options]="trackListOperatingTo" class="track" [(ngModel)]="lineItemModel.selectedTrackTo"
                placeholder="Select Track"
                [ngClass]="{'invalid-track': lineItemModel.errorMessageSelectedTrackTo !== null}" field="label"
                (onBlur)="loadDirectionDropdown(null)" (onChange)="onTrackToChange($event)"></p-dropdown>
            <div [hidden]="lineItemModel.errorMessageSelectedTrackTo === null">
                <p class="error-text">{{lineItemModel.errorMessageSelectedTrackTo}}</p>
            </div>
        </div>
    </div>
    <div class="line-item-row">
        <div class="line-item-column col-direction">
            <label style="margin-bottom:-7px;"> Direction </label>
            <p-dropdown [options]="directionList" [(ngModel)]="lineItemModel.selectedDirection"
                placeholder="Select Direction"
                [ngClass]="{'invalid-track': lineItemModel.errorMessageSelectedDirection !== null}"
                [style]="{'margin-top':'10px'}"></p-dropdown>
            <div [hidden]="lineItemModel.errorMessageSelectedDirection === null">
                <p class="error-text">{{lineItemModel.errorMessageSelectedDirection}}</p>
            </div>
        </div>
    </div>
    <div *ngIf="displayWarning" class="centered-warning red-warning">
        <p class="warning-text">The Point of Entry is not within the requested authority.</p>
    </div>
    <div *ngIf="displayPrefixWarning" class="centered-warning">
        <p class="warning-text">Verify the Point of Entry as it may be outside the requested limits.</p>
    </div>
</div>